import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

// Scoped Knowledge Routing deep-link params: an inbox row for a proposed
// knowledge addition links to
// /company/knowledge?kscope=<project|org>&ktarget=<projectId|orgId>&knowledge=<additionId>
// so the page opens on the right tab with that proposal focused. All optional;
// unrelated visits validate to undefined and are byte-identical.
interface KnowledgeSearch {
  kscope?: 'project' | 'org';
  ktarget?: string;
  knowledge?: string;
}

export const Route = createFileRoute('/_authenticated/company/knowledge')({
  beforeLoad: requireOrgAdminBeforeLoad,
  validateSearch: (search: Record<string, unknown>): KnowledgeSearch => ({
    kscope:
      search.kscope === 'project' || search.kscope === 'org'
        ? search.kscope
        : undefined,
    ktarget: typeof search.ktarget === 'string' ? search.ktarget : undefined,
    knowledge: typeof search.knowledge === 'string' ? search.knowledge : undefined,
  }),
}).lazy(() => import('./knowledge.lazy').then((d) => d.Route));
